/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
* BROWSER POLYFILLS
*/
(window as any).global = window;  // Run `npm install --save classlist.js`.

/** IE10 and IE11 requires the following for the Reflect API. */

//Required imports to get the application to even load in IE locally
//import "@angular-devkit/build-angular/node_modules/core-js/features/array";
//import "@angular-devkit/build-angular/node_modules/core-js/features/map";
//import "@angular-devkit/build-angular/node_modules/core-js/features/string";

////Required imports to be able to get to the dashboard following login in IE locally
//import "@angular-devkit/build-angular/node_modules/core-js/es"; //Something in es defines .values but can't figure out which one IE is looking for


////Required for http requests that roll objects up into the query string in IE locally and on DEV
//import "@angular-devkit/build-angular/node_modules/core-js/features/url-search-params";

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.


/* IE11 & Edge '.closest' usage */
import "element-closest";

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

 // (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 // (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 // (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

 /*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */




/***************************************************************************************************
 * APPLICATION IMPORTS
 */
